module.exports = __webpack_public_path__ + "static/2019-layer-2-208a4302e890f1dd71e72ebe0b824383.png";